/* NomadFlow — onglets des spécifications produit.
   Externalisé pour être cacheable et enrichi avec la navigation clavier ARIA. */
(() => {
  const activateTab = (section, tab, moveFocus = false) => {
    const tabs = Array.from(section.querySelectorAll('.npst-tab'));
    const panels = Array.from(section.querySelectorAll('.npst-panel'));
    const target = tab?.getAttribute('data-tab');
    if (!tab || !target) return;

    tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', String(isActive));
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel) => {
      const isActive = panel.id === target;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });

    if (moveFocus) tab.focus();
  };

  const initSection = (section) => {
    if (!section || section.dataset.npstInit === 'true') return;
    section.dataset.npstInit = 'true';

    const tabs = Array.from(section.querySelectorAll('.npst-tab'));
    if (!tabs.length) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(section, tab));

      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex === null) return;

        event.preventDefault();
        activateTab(section, tabs[nextIndex], true);
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-npst-section]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
